module.exports = __webpack_public_path__ + "static/media/165-belgium.d25b2714.svg";